<template lang="html">
  <section class="new-featured-vertical-img grid" v-if="dataContent">
    <router-link
      :to="{
        name: 'page-entry',
        params: {
          typeContent: this.dataContent.type,
          slug: this.dataContent.slug,
          typeMedia: this.typeMedia,
        },
      }"
      class="content-new"
      title="Enlace a la noticia"
    >
      <span
        v-if="typeContent == 'multimedia'"
        src="/img/img-test.png"
        :alt="dataContent.image_footer"
        :class="'icon-media typeMedia' + dataContent.file_type"
      ></span>
      <img
        :src="dataContent.image.url"
        :alt="dataContent.image_footer"
        class="img-new"
      />
      <!-- <span class="category">ÚLTIMA ENTREVISTA</span> -->
      <div class="info-box">
        <h2>
          <Markdown
            v-if="this.dataContent.name_markdown"
            class="title"
            :source="this.dataContent.name_markdown"
          />
        </h2>
        <p class="box-dates">
          <span class="date-text"
            >{{ currentDateTime(dataContent.publish_date) }}
          </span>
          <span class="author" v-if="dataContent.source">{{
            dataContent.source
          }}</span>

          <template v-for="theme in dataContent.themes" :key="theme.id">
            <span class="category-tag">{{ theme.name }}</span>
          </template>
          <span class="category-location" v-if="dataContent.zone">{{
            dataContent.zone.name
          }}</span>
        </p>
        <p class="dest">{{ cutText(dataContent.header, 100) }}</p>
        <!-- <p>
    “No vamos a estar callados ante un país que crece y no acaba de repartir bien ese crecimiento”
</p> -->
      </div>
    </router-link>
  </section>
</template>

<script lang="js">
import moment from 'moment'
import Markdown from 'vue3-markdown-it';
export default {
    name: 'new-featured-vertical-img',
    props: ['dataContent', 'typeMedia'],
    components: {
        Markdown
    },
    mounted() {

    },
    data() {
        return {

        }
    },
    methods: {
        currentDateTime(date) {
            return moment(date).locale('es').format('L')
        },


    },
    computed: {
        typeContent() {
            switch (this.dataContent.type) {
                case 'entry':
                    return 'noticia'
                case 'opinion':
                    return 'opinion'
                case 'interview':
                    return 'entrevista'
                case 'coverage':
                    return 'reportaje'
                case 'event':
                    return 'evento'
                case 'media':
                    return 'multimedia'
                default:
                    return 'noticia'
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/colours.scss";

.new-featured-vertical-img {
  cursor: pointer;

  .content-new {
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    position: relative;
    border-radius: 13px;
    padding-left: 10px;
    margin-bottom: 20px;

    .category {
      position: absolute;
      left: 0px;
      top: 10px;
      z-index: 2;
      background: $blue;
      font-weight: 900;
      color: white;
      font-size: 16px;
      padding: 5px 15px;
      border-radius: 13px;
      z-index: 0;
    }

    .icon-media {
      width: 50px;
      height: 50px;
      display: inline-block;
      position: absolute;
      top: 10px;
      left: 20px;
      background-position: center center;
      background-size: 45px;
      background-repeat: no-repeat;
      background-color: #0069b4b0;
      border-radius: 10px;

      &.typeMedia0 {
        background-image: url("/img/icons/icon-photo.svg");
        background-size: 30px;
      }

      &.typeMedia1 {
        background-image: url("/img/icons/icon-video.svg");
      }
    }

    .img-new {
      width: 100%;
      border-radius: 13px;
      height: 230px;
      object-fit: cover;
      object-position: center;
    }

    .info-box {
      width: 100%;
      padding: 20px 0px;
    }

    .dest {
      margin-bottom: 5px;
    }
  }
}

@media screen and (max-width: 845px) {
  .content-new .title,
  .content-new .title p {
    font-size: 18px;
  }

  .subtitle {
    font-size: 17px;
  }

  .content-new .img-new {
    height: 235px;
  }

  .new-featured-vertical-img .content-new {
    padding-left: 0;
  }

  .new-featured-vertical-img .content-new .info-box {
    padding: 10px 0;
  }
}
</style>
